import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import convert from "color-convert";

const ColorConverterComponent = () => {
    const [color, setColor] = useState({
        rgba: "255, 0, 0, 1",
        hex: "FF0000",
        hsl: "0, 100, 50",
        hsv: "0, 100, 100",
        cmyk: "0, 100, 100, 0",
    });

    const handleColorChange = (type, value) => {
        let rgba;

        switch (type) {
            case "rgba":
                rgba = value
                    .split(",")
                    .map((v, i) => (i < 3 ? Number(v) : parseFloat(v)));
                break;
            case "hex":
                rgba = [...convert.hex.rgb(value), 1];
                break;
            case "hsl":
                rgba = [...convert.hsl.rgb(value.split(",").map(Number)), 1];
                break;
            case "hsv":
                rgba = [...convert.hsv.rgb(value.split(",").map(Number)), 1];
                break;
            case "cmyk":
                rgba = [...convert.cmyk.rgb(value.split(",").map(Number)), 1];
                break;
            default:
                return;
        }

        setColor({
            rgba: rgba.join(", "),
            hex: convert.rgb.hex(rgba.slice(0, 3)),
            hsl: convert.rgb.hsl(rgba.slice(0, 3)).join(", "),
            hsv: convert.rgb.hsv(rgba.slice(0, 3)).join(", "),
            cmyk: convert.rgb.cmyk(rgba.slice(0, 3)).join(", "),
        });
    };

    const handleAlphaChange = (value) => {
        const rgba = color.rgba.split(", ");
        rgba[3] = value;
        handleColorChange("rgba", rgba.join(", "));
    };

    const renderInput = (label, type) => (
        <div className="flex justify-between items-center mb-2">
            <label className="font-bold w-1/4">{label}:</label>
            <input
                type="text"
                value={color[type]}
                onChange={(e) => handleColorChange(type, e.target.value)}
                className="border rounded p-2 w-3/4"
            />
        </div>
    );

    return (
        <div className="container mx-auto p-8 border border-#333">
            {" "}
            {/* добавлен бордер для контейнера */}
            {renderInput("RGBA", "rgba")}
            <div className="flex justify-between items-center mb-2">
                <label className="font-bold w-1/4">Alpha:</label>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={color.rgba.split(", ")[3]}
                    onChange={(e) => handleAlphaChange(e.target.value)}
                    className="w-3/4"
                />
            </div>
            {renderInput("HEX", "hex")}
            {renderInput("HSL", "hsl")}
            {renderInput("HSV", "hsv")}
            {renderInput("CMYK", "cmyk")}
            <div
                className="w-12 h-12 m-2 rounded-lg border border-#333"
                style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: `rgba(${color.rgba})`,
                }}
            ></div>{" "}
            {/* обновлен бордер для прямоугольника */}
        </div>
    );
};

export default ColorConverterComponent;

if (document.getElementById("color-converter")) {
    const colorConverterElement = document.getElementById("color-converter");
    const root = createRoot(colorConverterElement);
    const attributes = {};
    root.render(<ColorConverterComponent attributes={attributes} />);
}
